module.exports = __webpack_public_path__ + "img/correct-face.e696011c.jpg";